// Полифилл Buffer — нужен @ton/core для BoC-сериализации в браузере.
// Обязательно до любых других импортов, чтобы при инициализации модулей
// глобальный Buffer уже был доступен.
import { Buffer } from 'buffer';
if (typeof globalThis.Buffer === 'undefined') {
  (globalThis as unknown as { Buffer: typeof Buffer }).Buffer = Buffer;
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import TelegramAnalytics from '@telegram-apps/analytics';
import App from './app/App';
import { installMockTelegram } from '@/lib/mockTelegram';
import './i18n';
import './styles/tailwind.css';

installMockTelegram();

// Telegram Mini Apps Analytics — обязательно до render(), иначе теряем launch-event.
// Токен выдаётся в TON Builders → проект → Analytics → API key.
const analyticsToken = import.meta.env.VITE_TG_ANALYTICS_TOKEN as string | undefined;
const analyticsAppName = import.meta.env.VITE_TG_ANALYTICS_APP_NAME as string | undefined;
if (analyticsToken && analyticsAppName) {
  try {
    TelegramAnalytics.init({ token: analyticsToken, appName: analyticsAppName });
  } catch {
    /* analytics не должна валить рендер */
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
